import React from "react";
export default class OverallComponenant extends React.Component {
    constructor(opts) {
        super(opts);
        this.state = {
            colorcode: ''
        }
    }
    
    render() {
        const value = this.props.dataItem[this.props.field];
        let splitedStr = [];
        if (typeof value === 'string') {
            splitedStr=value.split('-')
        }
        return (
            <td>
                <div>
                    <span> {splitedStr[0]}</span>
                    <span className='yellowCell'> {splitedStr[1]}</span>
                </div>
            </td>
        );
    }
}
